/* recommendations.js — load via Shopify Section Rendering API */
(function () {
  'use strict';
  var holder = document.querySelector('[data-recommendations]');
  if (!holder) return;
  var url = holder.getAttribute('data-url');
  if (!url) return;
  fetch(url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        holder.innerHTML = fresh.innerHTML;
        // re-init reveal + carousel for injected content
        holder.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      }
    })
    .catch(function () {});
})();
